import React from 'react';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container">
        <div>
          <div><h1>Transform Your FMCG Distribution with <span>SellWise<span className='subName'>360</span></span></h1>
        <p className="subtitle">Complete SaaS solution with DMS SFA and Merchandizing platforms.<br/>
        Available on <a href="https://play.google.com/store/apps/details?id=com.ltapp_org.sellwise360" target="_blank" rel="noopener noreferrer"><span style={{"fontWeight":"bold", color:"orange"}}>Google Play</span></a> and <a href="https://apps.apple.com/ng/app/sellwise360/id6757250572" target="_blank" rel="noopener noreferrer"><span style={{"fontWeight":"bold", color:"orange"}}>App Store</span></a></p>
        {/* <div className="hero-buttons">
          <a href="#demo" className="cta-button">Get Started</a>
          <a href="#how-it-works" className="secondary-button">See How It Works</a>
        </div> */}
        
        </div><div><div>
            <img  style={{width:"20em"}} src="/images/app_icon.png" alt="Apps" />
          </div></div>
        </div>

        <div className="hero-image">
          <img src="/images/hero-dashboard.png" alt="SellWise Dashboard" />
        </div>
      </div>
    </section>
  );
};

export default Hero;